<template>
  <div>
    <v-sheet outlined class="pa-3 my-3" v-if="userBusinessInformation">
      <h4 class="blue--text mb-3" v-if="!userBusinessInformation.isSupplier">
        اطلاعات کاربر
      </h4>
      <h4 class="blue--text mb-3" v-else>اطلاعات صاحب کسب و کار</h4>
      <v-row v-if="userBusinessInformation.managerPerson">
        <v-col cols="12" md="4" sm="6">
          <business-information-text-data
            label="نام:"
            :text="userBusinessInformation.managerPerson.firstName"
          />
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <business-information-text-data
            label=" نام خانوادگی:"
            :text="userBusinessInformation.managerPerson.lastName"
          />
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <business-information-text-data
            label="شماره تلفن:"
            :text="userBusinessInformation.managerPerson.mobile"
          />
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <business-information-text-data
            label="جنسیت:"
            :text="getGender(userBusinessInformation.managerPerson.gender)"
          />
        </v-col>
        <!-- <v-col cols="12" md="4" sm="6">
          <business-information-text-data
            label="تاریخ تولد:"
            :text="
              userBusinessInformation.managerPerson.birthdate.includes(
                '0001'
              ) || !userBusinessInformation.managerPerson.birthdate
                ? '(وارد نشده)'
                : jalaliDate(userBusinessInformation.managerPerson.birthdate)
            "
          />
        </v-col> -->
        <v-col cols="12" md="4" sm="6">
          <business-information-text-data
            label="کد ملی:"
            :text="userBusinessInformation.managerPerson.nationalCode"
          />
        </v-col>
      </v-row>
      <template v-if="!userBusinessInformation.creatorIsManager">
        <h4 class="blue--text my-3">اطلاعات ثبت نام کننده</h4>
        <v-row v-if="userBusinessInformation.creatorPerson">
          <v-col cols="12" md="4" sm="6">
            <business-information-text-data
              label="نام:"
              :text="userBusinessInformation.creatorPerson.firstName"
            />
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <business-information-text-data
              label=" نام خانوادگی:"
              :text="userBusinessInformation.creatorPerson.lastName"
            />
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <business-information-text-data
              label="جنسیت:"
              :text="getGender(userBusinessInformation.creatorPerson.gender)"
            />
          </v-col>
          <!-- <v-col cols="12" md="4" sm="6">
            <business-information-text-data
              label="تاریخ تولد:"
              :text="
                userBusinessInformation.creatorPerson.birthdate.includes(
                  '0001'
                ) || !userBusinessInformation.creatorPerson.birthdate
                  ? '(وارد نشده)'
                  : jalaliDate(userBusinessInformation.creatorPerson.birthdate)
              "
            />
          </v-col> -->
          <v-col cols="12" md="4" sm="6">
            <business-information-text-data
              label="کد ملی:"
              :text="userBusinessInformation.creatorPerson.nationalCode"
            />
          </v-col>
        </v-row>
      </template>
    </v-sheet>
  </div>
</template>

<script>
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import BusinessInformationTextData from './BusinessInformationTextData.vue';
export default {
  mixins: [reusableMethodsMixin],
  components: {
    BusinessInformationTextData,
  },
  props: {
    userBusinessInformation: {
      type: Object,
      default: null,
    },
  },
  methods: {
    getGender(gender) {
      if (gender) {
        if (gender.toLowerCase() === 'male') {
          return 'مرد';
        }
        return 'زن';
      }
      return null;
    },
  },
};
</script>

<style></style>
